import Vue from 'vue'
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' // Vuesax styles
import 'material-icons/iconfont/material-icons.css' // Material-Icons

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#2a2f50',
      success: 'rgb(23, 201, 100)',
      // danger: 'rgb(242, 19, 93)',
      danger: '#cc0000',
      // warning: 'rgb(255, 130, 0)',
      warning: '#DE5433',
      dark: 'rgb(36, 33, 69)'
    }
  }
})
